import * as yup from "yup";
import {
  CashRounding,
  PaymentMethodFormValues,
  RoundingAlgorithm,
} from "./types";

export const roundingFormValues = {
  cashRounding: CashRounding.ROUND_TO_05,
  roundingAlgorithm: RoundingAlgorithm.ROUND_MIDPOINT_DOWN,
};

export const defaultFormValues: PaymentMethodFormValues = {
  payTypeId: "",
  name: "",
  enabled: true,
  assignToTerminal: true,
  terminalIdToAdd: undefined,
  retailerPayTypeId: undefined,
  // cash specific fields only required when payTypeId is "1"
  rounding: roundingFormValues,
};

// Define the rounding sub-schema
const roundingSchema = yup.object({
  cashRounding: yup.string().required("Cash rounding is required"),
  roundingAlgorithm: yup.string().required("Rounding algorithm is required"),
});

export const schema = yup.object().shape({
  id: yup.string().optional(),
  name: yup.string().required("Name is required"),
  payTypeId: yup.string().required("Payment Type is required"),
  enabled: yup.boolean().required("Enabled is required"),
  terminalIdToAdd: yup.string().optional(),
  retailerPayTypeId: yup.string().optional(),
  // Conditionally add the rounding field
  rounding: yup.object().when("payTypeId", {
    // Only allow (but not require) rounding if payTypeId is "1";
    // (you can also set `required: true` if it's required when payTypeId is "1")
    is: "1",
    then: roundingSchema.optional(),
    otherwise: yup.object().strip(), // Remove/display no rounding in other cases
  }),
  assignToTerminal: yup.boolean().optional(),
});
